export default {
    // 路由跳转，防止跳转到相同的路由地址
    toRoute(route, router, path) {
        if (route.fullPath !== path) {
            router.push(path)
        }
    }
}
